import AdminSection from "../../../shared/components/AdminSection";
import ImageUploadField from "../../../shared/components/ImageUploadField";
import { siteTexts } from "../../../shared/i18n/siteTexts";
import type { SiteContent } from "../../home/shared/types/siteContent";

type AdminContentIntroPanelsProps = {
  contentDraft: SiteContent;
  removeHeroImage: () => Promise<void>;
  updateAbout: (field: string, value: string | string[]) => void;
  updateHero: (field: string, value: string) => void;
};

export function AdminContentHeroPanel({
  contentDraft,
  removeHeroImage,
  updateHero,
}: Pick<
  AdminContentIntroPanelsProps,
  "contentDraft" | "removeHeroImage" | "updateHero"
>) {
  const t = siteTexts.admin;

  return (
    <AdminSection title={t.sections.hero}>
      <div className="form-grid">
        <label className="field">
          <span>{t.labels.title}</span>
          <input
            type="text"
            value={contentDraft.hero.title}
            onChange={(event) => updateHero("title", event.target.value)}
          />
        </label>
        <label className="field">
          <span>{t.labels.subtitle}</span>
          <textarea
            value={contentDraft.hero.subtitle}
            onChange={(event) => updateHero("subtitle", event.target.value)}
            rows={3}
          />
        </label>
        <label className="field">
          <span>{t.labels.ctaText}</span>
          <input
            type="text"
            value={contentDraft.hero.ctaLabel}
            onChange={(event) => updateHero("ctaLabel", event.target.value)}
          />
        </label>
        <label className="field">
          <span>{t.labels.ctaLink}</span>
          <input
            type="text"
            value={contentDraft.hero.ctaLink}
            onChange={(event) => updateHero("ctaLink", event.target.value)}
          />
        </label>
        <ImageUploadField
          label={t.labels.heroImage}
          value={contentDraft.hero.imageUrl}
          onChange={(nextValue) => updateHero("imageUrl", nextValue)}
          onRemove={removeHeroImage}
        />
      </div>
    </AdminSection>
  );
}

export function AdminContentAboutPanel({
  contentDraft,
  updateAbout,
}: Pick<AdminContentIntroPanelsProps, "contentDraft" | "updateAbout">) {
  const t = siteTexts.admin;

  return (
    <AdminSection title={t.sections.about}>
      <div className="form-grid">
        <label className="field">
          <span>{t.labels.title}</span>
          <input
            type="text"
            value={contentDraft.about.title}
            onChange={(event) => updateAbout("title", event.target.value)}
          />
        </label>
        <label className="field">
          <span>{t.labels.description}</span>
          <textarea
            value={contentDraft.about.description}
            onChange={(event) => updateAbout("description", event.target.value)}
            rows={4}
          />
        </label>
        <label className="field">
          <span>{t.labels.bulletsPerLine}</span>
          <textarea
            value={contentDraft.about.bullets.join("\n")}
            onChange={(event) =>
              updateAbout(
                "bullets",
                event.target.value
                  .split("\n")
                  .map((item) => item.trim())
                  .filter(Boolean),
              )
            }
            rows={4}
          />
        </label>
      </div>
    </AdminSection>
  );
}
